import { Card, Stack, Text } from "@mantine/core";

interface KpiCardProps {
  label: string;
  value: string | number;
  sub?: string | null;
}

export function KpiCard({ label, value, sub }: KpiCardProps) {
  return (
    <Card withBorder padding="md" radius="md">
      <Stack gap={4}>
        <Text size="xs" c="dimmed" tt="uppercase" fw={600}>
          {label}
        </Text>
        <Text size="xl" fw={700}>
          {value}
        </Text>
        {sub ? (
          <Text size="xs" c="dimmed">
            {sub}
          </Text>
        ) : null}
      </Stack>
    </Card>
  );
}
